<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.6">
    <path
      opacity="0.65"
      d="M20.0498 22C20.2822 22 20.4805 21.9111 20.6582 21.7334L25.874 16.4014C26.0244 16.251 26.0996 16.0664 26.0996 15.8477C26.0996 15.4033 25.7578 15.0479 25.3135 15.0479C25.0947 15.0479 24.8965 15.1367 24.7393 15.2871L20.0498 20.0996L15.3604 15.2871C15.21 15.1436 15.0117 15.0479 14.793 15.0479C14.3418 15.0479 14 15.4033 14 15.8477C14 16.0664 14.0752 16.251 14.2256 16.4014L19.4414 21.7334C19.6191 21.918 19.8174 22 20.0498 22Z"
      fill="currentColor"
    />
  </g>
</svg>
